import { useEffect, useState } from "react";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { useSelector } from "react-redux";
import { getThemeMode } from "../../../../../utils/helper";
import ChatFullScreenButton from "../../../../chatFullScreenButton";

const InnerPage = ({ setShowInnerPage, activeWidgetBlock }) => {
  const { widgetConfig } = useSelector((state) => ({
    widgetConfig: state.messages.widgetConfig,
  }));
  const [isBgLight, setIsBgLight] = useState(false);
  
  useEffect(() => {
    if(widgetConfig?.config?.widgetId) {
      setIsBgLight(getThemeMode(widgetConfig?.widgetConfig?.lookAndFeel?.backgroundColor))
    }
  }, [widgetConfig])
  
  const handleBack = () => {
    setShowInnerPage(false)
  }
  return (
    <div className='rcw-home-inner-page'>
      <ChatFullScreenButton isBgLight={isBgLight} />
      <div className='rcw-inner-header' style={{ background: widgetConfig?.widgetConfig.lookAndFeel?.backgroundColor }}>
        <div className="rcw-inner-back" onClick={handleBack}> 
          <div className="rcw-inner-back-icon">
            <MdOutlineKeyboardArrowLeft cursor={'pointer'} size={30} color={isBgLight ? '#000000' : '#ffffff'} />
          </div>
        </div>
        <div className='rcw-message-title' style={{ color: isBgLight ? '#000000' : '#ffffff' }}>{activeWidgetBlock?.title}</div>
        <div className="rcw-message-right"></div>
      </div>
      <iframe src={activeWidgetBlock?.url} style={{
        height: 'calc(100% - 64px)',
        width: '100%',
        position: 'fixed',
        top: '64px',
        bottom: 0,
        right: 0,
        left: 0,
        border: 'none'
      }}></iframe>
    </div>
  );
};

export default InnerPage;
